module.exports = __webpack_public_path__ + "static/tabs-number-dont-c658b4fc23b94679eb7923f09211644c.png";